import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            justifyContent: 'center',
            width: '100%',
            alignItems: 'center',
            backgroundColor: 'background.brand',
        },
        containerDesktop: {
            h: remCalc(44),
            display: {base: 'none', lg: 'flex'},
        },
        containerMobile: {
            display: {base: 'flex', lg: 'none'},
            h: remCalc(32),
            px: remCalc(16),
        },
        icon: {
            color: 'text.inverse',
            width: remCalc(1),
            height: remCalc(29),
            opacity: 0.2,
        },
        iconArrow: {
            color: 'text.inverse',
            alignItems: 'center',
            height: remCalc(16),
            width: remCalc(16),
            cursor: 'pointer',
        },
        label: {
            textStyle: 'body-small',
        },
        labelSmall: {
            textStyle: 'body-xsmall',
        },
        hstack: {
            gap: remCalc(26),
        },
    },
    parts: ['container', 'label', 'icon'],
}
